


























































import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import Menu from '@/components/Menu.vue';
import { getToken, setLocale, removeToken, removeUserInfo, setUserInfo, getSchoolInfo } from '@/utils/utils';
import { PersonalCenterController, SchoolController } from '@/services/request.service';
import { ParentResponse } from '@/services/__model';
import config from '@/school.config';

@Component({
  components: {
    Menu,
  },
})
export default class Main extends Vue {
  @Inject() public readonly reloadPage!: any;
  public visible: boolean = false;
  public userInfo: any = {};
  public userName: string = '';
  public logoUrl: any = '';
  public config = config;
  public schoolName: any = '';
  public created(): void {
    this.schoolName = getSchoolInfo().shortName;
    if (this.isLogin) {
      this.getParentInfoById();
    }
    this.getLogo();
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
  @Watch('$route', { immediate: true })
  public refresh(to: any, from: any): void {
    const newId: any = to && to.params && to.params.id ? to.params.id : null;
    const lastId: any = from && from.params && from.params.id ? from.params.id : null;
    if (newId !== lastId) {
      this.$store.commit('reset');
    }
    if (newId !== null && lastId !== null && newId !== lastId) {
      this.reloadPage();
    }
  }

  public getLogo() {
    SchoolController.getAllSchools().then((res: any) => {
      if (this.config[this.schoolName].schoolId === 1) {
        this.logoUrl = res.data[0].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 2) {
        this.logoUrl = res.data[1].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 3) {
        this.logoUrl = res.data[2].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 4) {
        this.logoUrl = res.data[3].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 5) {
        this.logoUrl = res.data[4].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 6) {
        this.logoUrl = res.data[5].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 7) {
        this.logoUrl = res.data[6].logoUrl;
      }
      if (this.config[this.schoolName].schoolId === 9) {
        this.logoUrl = res.data[7].logoUrl;
      }
    });

    return {};
  }
  public getParentInfoById(): void {
    PersonalCenterController.getParentInfoById().then(res => {
      this.userInfo = res.data ? res.data : {};
      if (this.userInfo.name || this.userInfo.enName) {
        this.userName = this.userInfo.name + this.userInfo.enName;
      } else {
        this.userName = this.userInfo.accountMobile;
      }
      setUserInfo(res.data);
    });
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get isLogin(): string {
    return getToken();
  }

  public onHeaderClick({ key }: any): void {
    if (key === 'zh' || key === 'en') {
      this.changeLocale(key);
    } else if (key === 'logout') {
      this.$store.commit('reset');
      this.logout();
    }
  }

  public logout(): void {
    removeToken();
    removeUserInfo();
    this.jumpToLogin();
  }

  public jumpToLogin(): void {
    this.$router.push({ name: 'login' });
  }

  public changeLocale(language: string): void {
    const currentLocale = this.$i18n.locale;
    if (currentLocale === 'zh' && language !== 'zh') {
      this.$i18n.locale = 'en';
      this.$store.commit('changeLocale', 'en');
      setLocale('en');
    } else if (currentLocale === 'en' && language !== 'en') {
      this.$i18n.locale = 'zh';
      this.$store.commit('changeLocale', 'zh');
      setLocale('zh');
    }
  }

  public showHeaderMenu(e: any): void {
    const ev = e && window.event;
    this.visible = !this.visible;
    if (ev) {
      ev.stopPropagation();
    }
  }

  public closeHeaderMenu(): void {
    this.visible = false;
  }

  public jumpToUserCenter(): void {
    this.$router.push({ name: 'userCenter' });
  }
}
